var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox3Line = function SvgBox3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 3.75 7.125 4.125v8.25L12 20.25l-7.125-4.125v-8.25zM7.12 8.308 12 11.133l4.88-2.825L12 5.483zM6.375 9.61v5.65l4.875 2.823v-5.65zm6.375 8.473 4.875-2.823V9.61l-4.875 2.822z"
  })));
};
export default SvgBox3Line;